import { ModelAttributes, ReadonlyModel, model, modelConfig } from "@mixitone/oom";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    agent_chat_id: {
      type: "string",
    },
    content: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    in_response_to_message_id: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    is_hidden: {
      type: "boolean",
    },
    metadata: {
      type: "json",
      jsonType: {} as Record<string, any>,
    },
    role: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {},
  {},
);

interface AgentMessage extends ModelAttributes<typeof config> {}

@model("agent_messages", config)
class AgentMessage extends ReadonlyModel<typeof config> {
  isTemporary: boolean = false;
  wasStopped: boolean = false;
}

export default AgentMessage;
